<template>
  <div
    v-show="!hasCookie"
    class="cookie-agreement flex md:flex-col items-start justify-between px-6 py-5 space-x-10 md:space-x-0 md:space-y-5"
  >
    <div class="flex space-x-5 md:space-x-0">
      <img src="@/assets/icons/icon-cookie.svg" alt="icon-cookie" class="cookie-agreement__icon lg:hidden" />
      <div class="text-primary-50 text-left text-lg sm:text-base" v-html="$t('common.cookie-agreement')"></div>
    </div>
    <Button palette="neutral-border" class="cookie-agreement__btn" @click="onClick">
      {{ $t('common.accept-and-close') }}
    </Button>
  </div>
</template>

<script>
import Button from '@/components/UI/Button.vue';

export default {
  name: 'CookieAgreement',
  components: {
    Button,
  },
  data() {
    return {
      hasCookie: false,
    };
  },
  mounted() {
    const { cookie } = document;
    this.hasCookie = !!cookie;
  },
  methods: {
    onClick() {
      document.cookie = 'accept=true; max-age=604800';
      this.hasCookie = true;
    },
  },
};
</script>

<style lang="scss">
.cookie-agreement {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #1551e5;
  z-index: 1000;

  & .cookie-agreement__icon {
    width: 60px;
    height: 60px;
  }

  & .cookie-agreement__btn {
    width: 600px;
    border-radius: 0;
    text-transform: uppercase;

    @media(max-width: 768px) {
      width: 100%;
    }
  }
}
</style>
